<template>
	<div class="hidden lg:block">
		<div class="hello">
			<div class="icon">
				<img :src="log" alt="" />
			</div>
			<div class="tab">
				<el-menu
					:default-active="activeIndex"
					class="el-menu-demo"
					mode="horizontal"
					@select="handleSelect"
				>
					<el-menu-item index="1">首页</el-menu-item>
					<el-sub-menu index="2">
						<template #title>解决方案</template>
						<el-menu-item index="2-1">EPM平台</el-menu-item>
						<el-menu-item index="2-2">绩效管理</el-menu-item>
						<el-menu-item index="2-3">CRM系统</el-menu-item>
						<el-menu-item index="2-4">项目管理</el-menu-item>
						<el-menu-item index="2-5">全面预算</el-menu-item>
						<!-- <el-sub-menu index="2-6">
              <template #title>专业审计</template> -->
						<el-menu-item index="2-6-1">审计作业平台</el-menu-item>
						<el-menu-item index="2-6-2">函证管理系统</el-menu-item>
						<!-- <el-menu-item index="2-7">货运管理平台</el-menu-item> -->
						<!-- </el-sub-menu> -->
					</el-sub-menu>
					<el-menu-item index="3">服务与支持</el-menu-item>
					<el-menu-item index="4">合作伙伴</el-menu-item>
					<el-menu-item index="5">关于银杰</el-menu-item>
				</el-menu>
			</div>
			<div class="apply">
				<el-button type="primary" size="large" @click="apply"
					>演示申请</el-button
				>
			</div>
		</div>
	</div>
	<div class="block lg:hidden fiexdbox">
		<div class="moible_header">
			<img src="@/assets/mobileimg/mobilelog.png" alt="" class="img1" />
			<img
				src="@/assets/mobileimg/mobileopen.png"
				alt=""
				class="img2"
				@click="openright"
			/>
		</div>
		<el-drawer v-model="drawer" :direction="direction" size="80%">
			<template #title>
				<div>
					<img
						src="@/assets/mobileimg/mobilelog.png"
						alt=""
						style="width: 35%"
					/>
				</div>
			</template>
			<template #default>
				<el-row class="tac">
					<el-col :span="24">
						<el-menu
							default-active="2"
							class="el-menu-vertical-demo"
							@select="handleSelect"
						>
							<el-menu-item index="1">首页</el-menu-item>
							<el-sub-menu index="2">
								<template #title>解决方案</template>
								<el-menu-item index="2-1">EPM平台</el-menu-item>
								<el-menu-item index="2-2">绩效管理</el-menu-item>
								<el-menu-item index="2-3">CRM系统</el-menu-item>
								<el-menu-item index="2-4">项目管理</el-menu-item>
								<el-menu-item index="2-5">全面预算</el-menu-item>
								<el-sub-menu index="2-6">
									<template #title>专业审计</template>
									<el-menu-item index="2-6-1">审计作业平台</el-menu-item>
									<el-menu-item index="2-6-2">函证管理系统</el-menu-item>
								</el-sub-menu>
								<!-- <el-menu-item index="2-7">货运管理平台</el-menu-item> -->
							</el-sub-menu>
							<el-menu-item index="3">服务与支持</el-menu-item>
							<el-menu-item index="4">合作伙伴</el-menu-item>
							<el-menu-item index="5">关于银杰</el-menu-item>
						</el-menu>
					</el-col>
				</el-row>
				<div class="mobile_apply">
					<el-button type="primary" size="large" @click="apply"
						>演示申请</el-button
					>
				</div>
			</template>
		</el-drawer>
	</div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, toRefs } from "vue";
import { onBeforeRouteUpdate, useRouter } from "vue-router";

export default defineComponent({
	name: "HomeHeader",
	setup() {
		const headerList = ref([
			{
				key: "1",
				name: "HomeMain",
			},
			{
				key: "3",
				name: "ServiceSupport",
			},
			{
				key: "4",
				name: "PartnerYj",
			},
			{
				key: "5",
				name: "IntroduceYjkj",
			},
		]);
		const activeIndex = ref("1");

		const router = useRouter();
		const routerName = router.currentRoute.value.name as string;
		if (routerName != "") {
			if (routerName == "SolutionView") {
				router.push({
					name: "SolutionView",
					params: {
						id: "2-1",
					},
				});
				activeIndex.value = "2-1";
			} else {
				router.push({
					name: routerName,
				});
				let result = headerList.value.filter((ele) => ele.name == routerName);
				if (result.length > 0) activeIndex.value = result[0].key;
			}
		}
		const handleSelect = (key: string, keyPath: string[]) => {
			switch (key) {
				case "1":
					router.push({
						name: "HomeMain",
					});
					break;
				case "2-1":
				case "2-2":
				case "2-3":
				case "2-4":
				case "2-5":
				case "2-6-1":
				case "2-6-2":
				case "2-7":
					router.push({
						name: "SolutionView",
						params: {
							id: key,
						},
					});
					break;
				case "3":
					router.push({
						name: "ServiceSupport",
					});
					break;
				case "4":
					router.push({
						name: "PartnerYj",
					});
					break;
				case "5":
					router.push({
						name: "IntroduceYjkj",
					});
					break;
				default:
					router.push({
						name: "about",
					});
					break;
			}
			data.drawer = false;
		};
		const data = reactive({
			log: require("@/assets/images/indexlogo.png"),
			apply: () => {
				router.push({
					name: "ApplicationExperience",
				});
				activeIndex.value = "";
				data.drawer = false;
			},
			drawer: false,
			direction: "rtl",
			openright: () => {
				data.drawer = true;
			},
		});
		onBeforeRouteUpdate((to: any, from: any) => {
			let router_name = to.name;
			if (router_name == "SolutionView") {
				// router.push({
				// 	name: "SolutionView",
				// 	params: {
				// 		id: "2-1",
				// 	},
				// });
				activeIndex.value =
					to.params && to.params.id != "" ? to.params.id : "2-1";
			} else {
				// router.push({
				// 	name: router_name,
				// });
				let result = headerList.value.filter((ele) => ele.name == router_name);
				if (result.length > 0) activeIndex.value = result[0].key;
			}
		});
		return {
			activeIndex,
			handleSelect,
			...toRefs(data),
		};
	},
});
</script>

<style scoped lang="scss">
.hello {
	border-bottom: 1px solid #e6e6e6;
	min-width: 1366px;
	max-width: 1920px;
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.icon {
	flex: 1;
	img {
		margin: 0 auto;
	}
}
.tab {
	flex: 1;
}
.tab ::v-deep .el-menu--horizontal {
	justify-content: center;
	border-bottom: none;
}
.tab ::v-deep li {
	font-size: 14px;
	font-weight: 400;
	color: #0f0f0f;
}
.apply {
	flex: 1;
	text-align: center;
}
a {
	color: #42b983;
}
.tab ::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
	background: none !important;
}
.el-button {
	width: 120px;
	background-color: #008bff;
	color: #fff;
}
.fiexdbox {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 99999999;
}
.moible_header {
	width: 100%;
	height: 40px;
	padding: 10px 20px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	border-bottom: 1px solid #e6e8eb;
	background-color: #ffffff;
	.img1 {
		width: 100px;
		height: 20px;
	}
	.img2 {
		width: 15px;
		height: 15px;
	}
}
:deep(.el-drawer__header) {
	margin-bottom: 0;
	align-items: center;
	justify-content: space-between;
	flex-direction: row;
	flex-wrap: nowrap;
}
:deep(.el-drawer__body) {
	padding: 0;
}
.el-menu {
	border-right: #ffffff;
}
.mobile_apply {
	margin-top: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	.el-button {
		width: 163px;
		height: 42px;
	}
}
:deep(.el-sub-menu__title) {
	font-size: 15px;
	font-weight: 400;
	color: #0f0f0f;
}
:deep(.el-menu-item) {
	font-size: 16px;
	font-weight: 400;
	color: #0f0f0f;
}
</style>
